const initial = window.__INITIAL_STATE__; // eslint-disable-line no-underscore-dangle
const seed = (initial && initial.search) ? initial.search : {};

const store = {
	namespaced: true,

	state: {
		userSearchType: 'Vehicle',
		query: seed.query || {},
		dealership_id: (typeof seed.dealership_id !== 'undefined') ? seed.dealership_id : null
	},

	mutations: {
		setSearchType(state, val) {
			state.userSearchType = val;
		},
		setQuery(state, val) {
			state.query = val;
		},
		setDealershipId(state, val) {
			state.dealership_id = val;
		}
	}
};


export default store;
